@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.form {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: stretch;
  margin: 0 auto;
  max-width: 445px;
  margin-top: 10px;

  @include for-phone-only {
    margin: 0;
  }
}

.fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.required {
  color: var(--red-50);
  margin-left: 2px;
}

.requirementOptions {
  display: flex;
  gap: 12px;
}

.passwordRequirement {
  display: flex;
  gap: 1px;
  align-items: center;
}

.success {
  padding-bottom: 2px;
}

.passwordValidationContainer {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.errorMessage {
  margin: 0;
}

.scrollContainer {
  margin-top: 50px;
}

.logo {
  position: absolute;
  top: -90px;
  left: 50%;
  transform: translateX(-50%);
}
